import type { DateFilter } from '@/types/scheduling-api';
import type { CalendarView } from '@/scheduling/store/scheduling-store';

/**
 * Bridge the wire-side `DateFilter` enum to the store-side `CalendarView`
 * enum. The two diverge on Room/ByRoom + Doctor/ByDoctor only (history:
 * the API uses the bare label, the React store carried the "By…"
 * wording from the Flutter source). Day/Week/Month are identical on
 * both sides.
 *
 * Why exhaustive: the `never` default catches any future DateFilter
 * member added without a matching arm at compile time. Samer review
 * on PR #372 §4 asked for this rather than the ternary chain it
 * replaced, which would silently fall through and use the wrong scope
 * for realtime appointment merging.
 */
export function dateFilterToCalendarView(filter: DateFilter): CalendarView {
  switch (filter) {
    case 'Day':
    case 'Week':
    case 'Month':
      return filter;
    case 'Room':
      return 'ByRoom';
    case 'Doctor':
      return 'ByDoctor';
    default: {
      const _exhaustive: never = filter;
      return _exhaustive;
    }
  }
}
